module.exports = __webpack_public_path__ + "payment-title-bg.06d10139fd7a852f7d1c.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/img/payment-title-bg.jpg
// module id = ../../../../../src/assets/corporate/img/payment-title-bg.jpg
// module chunks = styles